module.exports = __webpack_public_path__ + "media/20241210.67a3e7fc.mp4";